import * as angular from 'angular';
import { IExcludedCategory } from '../../models/models';

class SelectCategoryDialogController implements ng.IController {
    public static $inject = [
    ];

    public columns: IExcludedCategory[][];
    public selectedIds: number[];
    public disabledIds: number[];
    public resolve: {
        categoriesIDs: number[],
        disabledCategoriesIDs: number[],
        categories: IExcludedCategory[];
    };

    private modalInstance: ng.ui.bootstrap.IModalInstanceService = this as any;

    // tslint:disable-next-line:no-empty
    constructor() {}

    public async $onInit() {
        this.selectedIds = [...this.resolve.categoriesIDs];
        this.disabledIds  = [...this.resolve.disabledCategoriesIDs];
        const half = Math.ceil(this.resolve.categories.length / 2);
        const rightColumn = [...this.resolve.categories];
        const leftColumn = rightColumn.splice(0, half);
        this.columns = [leftColumn, rightColumn];
    }

    public close() {
        this.modalInstance.close();
    }

    public save() {
        this.modalInstance.close({ $value: this.selectedIds });
    }

    public categorySelected(id: number): boolean {
        return !!this.selectedIds.find((selectedId) => selectedId === id);
    }

    public categoryDisabled(id: number): boolean {
        return !!this.disabledIds.find((disabledId) => disabledId === id);
    }

    public setSelected(id: number, value: boolean): void {
        if (value) {
            this.selectedIds.push(id);
        } else {
            this.selectedIds = this.selectedIds.filter((item) => item !== id);
        }
    }
}

angular.module('naut').component('selectCategory', {
    template: require('./select-category-dialog.component.html'),
    controller: SelectCategoryDialogController,
    controllerAs: 'ctrl',
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/vouchers/components/select-category-dialog/select-category-dialog.component.ts